import React, {Fragment, useState, useRef, useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {useParams} from "react-router";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import "../propiedadStyles.css"
// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import {supabase} from "./Main";

const Propiedad = () => {
    const { id } = useParams();
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [propiedad, setPropiedad] = useState(null);

    const getPropiedadById = async () => {
        const { data, error } = await supabase
            .from('propiedades')
            .select(`
                *,
                imagenes:imagenes(propiedad_id, imagen_url)
            `)
            .eq('id', id)
            .single();

        if (error) throw error;
        return data;
    };

    useEffect(() => {
        (async () => {
            const prop = await getPropiedadById();
            setPropiedad(prop);
        })();
    }, [id]);

    return (
        <div className="propiedad-container">
            {propiedad !== null && (
                <section className="propiedad-section">
                    {/* Galería principal */}
                    <Swiper
                        style={{
                            '--swiper-navigation-color': '#fff',
                            '--swiper-pagination-color': '#fff',
                        }}
                        loop={true}
                        spaceBetween={10}
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="propiedad-swiper-main"
                    >
                        {propiedad.imagenes.length === 0 ? (
                            <SwiperSlide>
                                <img
                                    src="https://t3.ftcdn.net/jpg/02/68/55/60/360_F_268556012_c1WBaKFN5rjRxR2eyV33znK4qnYeKZjm.jpg"
                                    alt="Imagen de propiedad por defecto"
                                />
                            </SwiperSlide>
                        ) : (
                            propiedad.imagenes.map((image, index) => (
                                <SwiperSlide key={`main-${index}`}>
                                    <img 
                                        src={image.imagen_url} 
                                        alt={`Vista ${index + 1} de la propiedad`}
                                    />
                                </SwiperSlide>
                            ))
                        )}
                    </Swiper>

                    {/* Galería de miniaturas */}
                    {propiedad.imagenes.length > 0 && (
                        <Swiper
                            onSwiper={setThumbsSwiper}
                            loop={true}
                            spaceBetween={10}
                            slidesPerView={4}
                            freeMode={true}
                            watchSlidesProgress={true}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="propiedad-swiper-thumbs"
                        >
                            {propiedad.imagenes.map((image, index) => (
                                <SwiperSlide key={`thumb-${index}`}>
                                    <img 
                                        src={image.imagen_url} 
                                        alt={`Miniatura ${index + 1}`}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}

                    {/* Información de la propiedad */}
                    <div className="propiedad-header">
                        <h2 className="propiedad-titulo">{propiedad.titulo}</h2>
                        <span className="propiedad-tipo">
                            {propiedad.tipo === "sale" ? "En Venta" : "En Alquiler"}
                        </span>
                    </div>

                    <div className="propiedad-info">
                        <p className="propiedad-direccion">
                            <strong>Dirección:</strong> {propiedad.direccion}
                        </p>
                        <p className="propiedad-descripcion">{propiedad.descripcion}</p>
                    </div>

                    <div className="propiedad-actions">
                        <span className="propiedad-precio">
                            {propiedad.precio ? `$${propiedad.precio}` : "Consultar precio"}
                        </span>
                        <a 
                            href="https://wa.link/u5kt3m" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="propiedad-whatsapp"
                        >
                            Consultar por WhatsApp
                        </a>
                    </div>
                </section>
            )}
        </div>
    );
};

export default Propiedad;